module.exports = __webpack_public_path__ + "img/gonetwork2_2.15c5e24d.png";